(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {

  $('.slideshow').slick({
    dots: true,
    slide: '.slideshow-slide',
    autoplay: true,
    autoplaySpeed: 7500,
    speed: 1000,
    appendArrows: $('.slideshow-tools > div'),
    appendDots: $('.slideshow-tools > div'),
    swipe: true
  })

})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_slideshow.js","/")